import { ILinkStyle } from '../models/index.js';
export const linkStyle: ILinkStyle = {
	color: 'blue',
	text: {
		decoration: 'underline',
	},
	cursor: 'pointer',
};
